import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import { createNote } from "../apis/noteService";

const NoteAdd = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [content, setContent] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSave = async () => {
    if (!content.trim()) {
      alert("請輸入記事內容");
      return;
    }

    if (!token) {
      alert("無效的連結網址");
      return;
    }

    setIsSubmitting(true);
    try {
      await createNote(token, { content });
      navigate(`/noteList/${token}`);
    } catch (error) {
      console.error("Error saving note:", error);
      alert("儲存失敗，請重試");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate(`/noteList/${token}`);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="px-3 py-5">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-800">新增記事</h1>
        </div>

        {/* Content Form */}
        <div className="bg-white border border-gray-200 rounded-lg p-4 mb-4">
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="輸入記事內容..."
            className="w-full h-[500px] resize-none border-none outline-none font-sans text-gray-700 leading-relaxed"
            autoFocus
          />
        </div>

        {/* Character count */}
        <div className="mb-4 text-right text-sm text-gray-500">
          {content.length} 字
        </div>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row sm:justify-center gap-3">
          <button
            onClick={handleCancel}
            className="w-full sm:w-auto px-6 py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors"
          >
            取消
          </button>
          <button
            onClick={handleSave}
            disabled={isSubmitting}
            className="w-full sm:w-auto px-6 py-3 bg-[#C83862] text-white rounded-lg hover:bg-[#A02850] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSubmitting ? "儲存中..." : "儲存"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoteAdd;